import React, { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import ModalWrapper from "../../../Components/Common/Portals/ModalWrapper";
import AssignPromoter from "../../../Components/EventMgt/AssignPromoter";
import Layout from "../../../Components/Layout";
import Input from "../../../Components/UiElement/FormElement/Input";
import useHttpHook from "../../../Hooks/HttpHook";
import {
  AddPromoter,
  AssignPromoterToEventApi,
  EventById,
  GetAllPromoters,
} from "../../../utils/ApiConstant";
import { PromoterLanguage } from "../../../utils/Languages";
import { createObjectForPaginatedResult } from "../../../utils/Helper";
import { toast } from "react-toastify";
import { showErrorToast } from "../../../utils/notify";

const toPromoterId = (value) => {
  if (value == null) return "";
  if (typeof value === "object") return String(value._id || value);
  return String(value);
};

const samePromoterSelection = (left, right) => {
  if (left.length !== right.length) return false;
  const rightIds = new Set(right);
  return left.every((id) => rightIds.has(id));
};

const AssignPromoterPage = () => {
  const [isModal, setIsModal] = useState(false);
  const [loading, sendRequest, error] = useHttpHook();
  const [promoters, setPromoters] = useState(null);
  const [promoters1, setPromoters1] = useState(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const [selectedPromoter, setSelectedPromoter] = useState([]);
  const [savedPromoterIds, setSavedPromoterIds] = useState([]);
  const [isAssignModal, setIsAssignModal] = useState(false);
  const [isAddModalSuccess, setIsAddModalSuccess] = useState(false);
  const [message, setMessage] = useState(null);
  const [isActive, setIsActive] = useState(false);
  const [search, setSearch] = useState("");
  useEffect(() => {
    getEvent();
    isActive ? getRegisterPromoters() : getAllPromoters();
  }, [isActive]);

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);
  const { eventId } = useParams();

  const getAllPromoters = useCallback(
    async (page = 1) => {
      try {
        const params = new URLSearchParams({
          page: String(page),
        });
        if (search?.trim()) {
          params.set("search", search.trim());
        }

        const res = await sendRequest(`${GetAllPromoters}?${params.toString()}`, {
          method: "get",
        });

        if (page === 1) {
          setPromoters(res);
        } else {
          setPromoters((prevState) => {
            return createObjectForPaginatedResult(res, prevState);
          });
        }
      } catch (error) {
        console.log({ error });
      }
    },
    [search]
  );

  const getRegisterPromoters = useCallback(
    async (page = 1) => {
      try {
        const params = new URLSearchParams({
          page: String(page),
          type: "pending",
        });
        if (search?.trim()) {
          params.set("search", search.trim());
        }

        const res = await sendRequest(`${GetAllPromoters}?${params.toString()}`, {
          method: "get",
        });
        if (page === 1) {
          setPromoters1(res);
        } else {
          setPromoters1((prevState) => {
            return createObjectForPaginatedResult(res, prevState);
          });
        }
      } catch (error) {
        console.log({ error });
      }
    },
    [search]
  );

  const reSendMail = async (data) => {
    try {
      const obj = {
        name: data.name,
        email: data.email,
        phone: data.phone,
        event: eventId,
        isReSendMail: true,
      };
      const res = await sendRequest(AddPromoter, {
        method: "post",
        data: obj,
      });
      if (res.status === 1) {
        toast("Email Invitation send successfully");
      }
    } catch (error) {
      console.log({ error });
    }
  };

  const changeModalState = () => {
    setIsModal(!isModal);
  };

  const onSubmit = async (data) => {
    try {
      const obj = {
        name: data.name,
        email: data.email,
        phone: data.phone,
        event: eventId,
      };
      const res = await sendRequest(AddPromoter, {
        method: "post",
        data: obj,
      });
      if (res.status === 1) {
        let data = {
          name: "",
          email: "",
          phone: "",
          event: "",
        };
        getAllPromoters();
        getEvent();
        reset(data);
        setIsModal(false);
        setIsAddModalSuccess(true);
      }
    } catch (error) {
      console.log({ error });
    }
  };

  const getEvent = async () => {
    try {
      const res = await sendRequest(`${EventById}${eventId}`, {
        method: "get",
      });

      if (res.status === 1) {
        const ids = (res.data.promoters || [])
          .map(toPromoterId)
          .filter(Boolean);
        setSavedPromoterIds(ids);
        setSelectedPromoter(ids);
      }
    } catch (error) {
      console.log({ error });
    }
  };

  const handleAssignPromoterToEvent = async () => {
    try {
      const res = await sendRequest(AssignPromoterToEventApi, {
        method: "put",
        data: {
          eventId: eventId,
          promoters: selectedPromoter,
        },
      });
      if (res.status === 1) {
        setSavedPromoterIds(selectedPromoter);
        setIsAssignModal(true);
        setMessage(res.message);
      }
    } catch (error) {
      console.log({ error });
    }
  };

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      isActive ? getRegisterPromoters() : getAllPromoters();
    }, 1000);

    return () => {
      clearTimeout(debounceTimeout);
    };
  }, [search]);

  const selectionUnchanged = samePromoterSelection(
    selectedPromoter,
    savedPromoterIds
  );
  const unassigningAll =
    savedPromoterIds.length > 0 && selectedPromoter.length === 0;

  const query = new URLSearchParams(window.location.search);

  const redirectUrl = query.get("redirectUrl");
  const pendingPromoter = () => {
    setIsActive(true);
  };
  return (
    <Layout
      BackAction={redirectUrl ? redirectUrl : "/organizer/myEvents"}
      Heading={PromoterLanguage.Assign.heading}
      TitleClassName="event-create-title"
      HeadClassName="event-page-head event-create-head event-create-head--split"
      CreateHead
      ExtraclassName="event-promoter-panel"
      activeMenuId="my-created-events"
      extraElement={
        <button
          className="event-promoter-header-btn"
          type="button"
          onClick={changeModalState}
        >
          {PromoterLanguage.Assign.addButtonText}
        </button>
      }
    >
      <div className="event-promoter-body">
        <nav className="event-promoter-tabs" aria-label="Promoter lists">
          <button
            type="button"
            className={`event-promoter-tab${!isActive ? " is-active" : ""}`}
            onClick={() => setIsActive(false)}
            aria-selected={!isActive}
          >
            Active Promoter
          </button>
          <button
            type="button"
            className={`event-promoter-tab${isActive ? " is-active" : ""}`}
            onClick={pendingPromoter}
            aria-selected={isActive}
          >
            Pending Promoter
          </button>
        </nav>

        <div className="event-promoter-toolbar">
          <div className="event-promoter-search">
            <label htmlFor="eventPromoterSearch">Search</label>
            <input
              type="search"
              id="eventPromoterSearch"
              className="event-promoter-search-input"
              placeholder="search by promoter name..."
              autoComplete="off"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          {!isActive && (
            <button
              type="button"
              className="event-promoter-assign-btn"
              disabled={loading || selectionUnchanged}
              onClick={handleAssignPromoterToEvent}
            >
              {unassigningAll ? "Unassign" : "Assign Selected"}
            </button>
          )}
        </div>

        {promoters && !isActive && (
          <AssignPromoter
            getPromoters={getAllPromoters}
            selectedPromoters={selectedPromoter}
            setSelectedPromoter={setSelectedPromoter}
            onPromoterDeleted={(id) => {
              setSavedPromoterIds((current) =>
                current.filter((item) => item !== id)
              );
            }}
            isLoading={loading}
            isError={error}
            list={promoters}
            isActive={isActive}
          />
        )}

        {promoters1 && isActive && (
          <AssignPromoter
            getPromoters={getRegisterPromoters}
            isLoading={loading}
            isError={error}
            list={promoters1}
            isActive={isActive}
            reSendMail={reSendMail}
          />
        )}

        {isModal && (
            <ModalWrapper
              title={PromoterLanguage.Assign.form.Heading}
              CloseModalHandler={changeModalState}
              formId="add-promoter"
              dialogClassName="event-promoter-modal-dialog"
              contentClassName="event-promoter-modal"
              headerClassName="event-promoter-modal-header"
              bodyClassName="event-promoter-modal-body"
              footerClassName="event-promoter-modal-footer"
              closeClass="event-promoter-modal-btn-close"
              submitClass="event-promoter-modal-btn-ok"
            >
              <form onSubmit={handleSubmit(onSubmit)} id="add-promoter">
                <Input
                  ValidationArr={[{ Type: "required" }]}
                  WrapperClass="col-lg-12"
                  element="text"
                  FieldName="name"
                  Register={register}
                  Errors={errors}
                  placeholder={PromoterLanguage.Assign.form.name.placeHolder}
                  Label={PromoterLanguage.Assign.form.name.label}
                />
                <Input
                  ValidationArr={[{ Type: "required" }]}
                  WrapperClass="col-lg-12"
                  element="text"
                  FieldName="email"
                  Register={register}
                  Errors={errors}
                  placeholder={PromoterLanguage.Assign.form.email.placeHolder}
                  Label={PromoterLanguage.Assign.form.email.label}
                />
                <Input
                  // ValidationArr={[{ Type: "required" }]}
                  WrapperClass="col-lg-12"
                  element="number"
                  FieldName="phone"
                  Register={register}
                  Errors={errors}
                  placeholder={PromoterLanguage.Assign.form.phone.placeHolder}
                  Label={PromoterLanguage.Assign.form.phone.label}
                />
              </form>
            </ModalWrapper>
          )}
          {isAssignModal && (
            <ModalWrapper
              title="Promoter Assign"
              CloseModalHandler={() => setIsAssignModal(false)}
              clickHandler={() => setIsAssignModal(false)}
              dialogClassName="event-promoter-assign-modal-dialog"
              contentClassName="event-promoter-assign-modal"
              headerClassName="event-promoter-assign-modal-header"
              bodyClassName="event-promoter-assign-modal-body"
              footerClassName="event-promoter-assign-modal-footer"
              closeClass="event-promoter-assign-modal-btn-close"
              submitClass="event-promoter-assign-modal-btn-ok"
            >
              <p>{message}</p>
            </ModalWrapper>
          )}
          {isAddModalSuccess && (
            <ModalWrapper
              title="Add Success"
              CloseModalHandler={() => setIsAddModalSuccess(false)}
              clickHandler={() => {
                setIsAddModalSuccess(false);
                getRegisterPromoters();
              }}
              dialogClassName="event-promoter-assign-modal-dialog"
              contentClassName="event-promoter-assign-modal"
              headerClassName="event-promoter-assign-modal-header"
              bodyClassName="event-promoter-assign-modal-body"
              footerClassName="event-promoter-assign-modal-footer"
              closeClass="event-promoter-assign-modal-btn-close"
              submitClass="event-promoter-assign-modal-btn-ok"
            >
              <p>
                Promoter is added successfully, an email is sent to promoter
                regarding promoting the event.{" "}
              </p>
            </ModalWrapper>
          )}
      </div>
    </Layout>
  );
};

export default AssignPromoterPage;
